import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, NgZone, Renderer2 } from '@angular/core';

import { GridDataResult, DataStateChangeEvent, PageChangeEvent, SelectionEvent, GridComponent } from '@progress/kendo-angular-grid';
import { SortDescriptor, process, State } from '@progress/kendo-data-query';
import { Router, ActivatedRoute } from '@angular/router';

// Models
import { EmployeeSetupModel, EmployeeConfigurationModel, EmployeeContractorMappingModel, ValidationModel } from '../../models/employee-setup.model';
import { PasswordValidationModel, EmailValidationModel, UserNameValidationModel } from '../../models/common-validation.model';
import { ContractorConfigurationModel } from '../../models/contractordetailsmodel';
import { AppenateCreateUserModel, AppenateDeleteUserModel } from '../../models/appenate-createuser.model';
import { NotificationModel } from '../../models/notification.model';
// Services
import { ClientService } from '../../services/client.service';
import { EmployeeSetupService } from '../../services/employee-setup.service';
import { ContractorDetailsService } from '../../services/contractor-details.service';
import Swal from 'sweetalert2';
import { AuthService } from '../../services/auth.service';
import { AppCode } from '../../../app.code';
import { async } from 'rxjs/internal/scheduler/async';
import { data } from 'jquery';
import { ExcelExportData } from '@progress/kendo-angular-excel-export';
import { DepartmentConfigurationModel } from '../../models/department-setup.model';

//component
import { DepartmentSetupComponent } from 'src/app/shared/dynamic-controls/department-setup/department-setup.component';
import { ContractorSetupComponent } from 'src/app/shared/dynamic-controls/contractor-setup/contractor-setup.component';

import { AppenateService } from '../../services/appenate.service';

@Component({
  selector: 'app-employee-setup',
  templateUrl: './employee-setup.component.html',
  styleUrls: ['./employee-setup.component.css']
})
export class EmployeeSetupComponent implements OnInit {
  @Input() public employeeConfiguration: EmployeeConfigurationModel = new EmployeeConfigurationModel();
  @Input() public contractorConfiguration: ContractorConfigurationModel = new ContractorConfigurationModel();
  @Input() public departmentConfiguration: DepartmentConfigurationModel = new DepartmentConfigurationModel();
  @Output() public outpkTableId = new EventEmitter<string>();

  state: State =
    {
      skip: 0,
      take: 100,
      filter: {
        logic: 'and',
        filters: []
      }
    }
  public sort: SortDescriptor[] = [];
  public gridView: GridDataResult;
  userRoles: string = "";
  showModal: boolean = false;
  skip: number = 0;
  clientId: string = "";
  userEmail: string = "";
  pageSize: number = 100;
  employeeList = [];
  btnName: string = "SUBMIT";
  client: any = {};
  employeeSetupModel: EmployeeSetupModel = new EmployeeSetupModel();
  validationModel = new ValidationModel;
  isValidForm: boolean = null;
  loading: boolean = false;
  gridHeight: number = 650;
  gridRowCount: number = 0;
  addEditFormName: string = "";
  base64textString: String = "";
  employeeContractorMappingModel: EmployeeContractorMappingModel = new EmployeeContractorMappingModel();
  errors: string;
  model: any = {};
  password: string = "";
  loginFieldsDisabled: boolean = false;
  passwordValidationModel: PasswordValidationModel = new PasswordValidationModel();
  emailValidationModel: EmailValidationModel = new EmailValidationModel();
  userNameValidationModel: UserNameValidationModel = new UserNameValidationModel();
  appenateCreateUser: AppenateCreateUserModel = new AppenateCreateUserModel();
  appenateDeleteUser: AppenateDeleteUserModel = new AppenateDeleteUserModel();
  selectEmployeeSectionShowModal: boolean = false;
  selectEmployeeSectionShowModalClass: string = "modal fade";
  hideSelectDetailSection: boolean = false;
  emailLabelText: string = "Email";
  passwordLabelText: string = "Password for Web-Login";
  designationList: any;
  Email: string = "";
  CompanyId: number = 0;
  IntegrationKey: string = "";
  panelAddEditVisible: boolean = false;

  @ViewChild('employeePanelAddEdit') employeePanelAddEditRef: ElementRef;
  @ViewChild('employeeFormModalPopup') public employeeFormModalPopupRef: ElementRef;

  @ViewChild('panelGridModalPopupEmployee') panelGridModalPopupRef: ElementRef;
  @ViewChild('panelGridEmployee') public panelGridRef: ElementRef;

  @ViewChild('appDepartment') public appDepartment: DepartmentSetupComponent;
  @ViewChild(ContractorSetupComponent) public appContractor: ContractorSetupComponent;



  constructor(private clientService: ClientService, private employeeSetupService: EmployeeSetupService,
    private contractorDetailsService: ContractorDetailsService, private authService: AuthService,
    private appCode: AppCode, private renderer: Renderer2, private router: Router, private appenateService: AppenateService) {
    this.client = this.clientService.getClient();
    this.showModal = (!this.employeeConfiguration.addEditInModalPopUp) ? true : this.showModal;
    this.allData = this.allData.bind(this);
  }


  ngOnInit() {
    this.addEditFormName = this.employeeConfiguration.addFormName;

    // Set Grid Height
    this.setGridHeight();

    // Clear Fields
    this.onClear();

    // Get Employee List
    this.getEmployeeList();

    // Get Designation List
    this.bindDesignationList();
  }
  ngAfterViewInit() {
    if (this.employeeConfiguration.addEditInModalPopUp) {
      this.renderer.appendChild(this.employeeFormModalPopupRef.nativeElement, this.employeePanelAddEditRef.nativeElement);
    }
    if (this.employeeConfiguration.selectEmployeeSection) {
      this.renderer.appendChild(this.panelGridModalPopupRef.nativeElement, this.panelGridRef.nativeElement);
    }
  }
  onResize() {
    this.setGridHeight();
  }

  setGridHeight() {
    var windowHeight = window.innerHeight;
    this.gridHeight = this.employeeConfiguration.gridHeight == 0 ? windowHeight : this.employeeConfiguration.gridHeight;
    this.gridRowCount = this.gridView != undefined ? this.gridView.total : 0;
    this.appCode.setPageHeight();
  }

  // CLEAR
  onClear() {
    this.outpkTableId.emit("0");
    this.employeeSetupModel = new EmployeeSetupModel();
    this.password = "";
    this.emailLabelText = "Email";
    this.passwordLabelText = "Password for Web-Login";
    this.loginFieldsDisabled = false;
    this.addEditFormName = "Add Employee";
    this.btnName = "SUBMIT";
    this.contractorConfiguration.selectedValueContractorDropDownList = "0";
    this.departmentConfiguration.selectedValueDepartmentDropDownList = ["0", "0"];
    this.validationModel = new ValidationModel();
    this.emailValidationModel = new EmailValidationModel();
    this.passwordValidationModel = new PasswordValidationModel();
    this.userNameValidationModel = new UserNameValidationModel();
    this.addEditPanelVisibility();
  }

  openAddEmployee() {
    this.onClear();
    this.addEditFormName = this.employeeConfiguration.addFormName;
    //this.scrollTo('panelAddEdit');
    this.addEditPanelVisibility();
  }

  // To Apply Validation Form
  async validateFormData() {
    if (this.employeeConfiguration.displayContractorDropDownList) {
      this.validationModel.isContractorDDLValid = this.employeeSetupModel.tblContractorId == 0 ? false : true;
    }

    if (this.employeeConfiguration.displayDepartmentDropDownList) {
      this.validationModel.isDepartmentValid = this.employeeSetupModel.tblDepartmentId == 0 ? false : true;
    }

    if (this.employeeConfiguration.requiredFields.employeeCode && !this.employeeConfiguration.autoGenerateEmployeeCode && this.employeeSetupModel.employeeCode == "") {
      this.validationModel.isEmployeeCodeValid = false;
      this.validationModel.employeeCodeValidationMessage = "Employee Code is required.";
    }
    else {
      this.validationModel.isEmployeeCodeValid = true;
    }
    if (this.validationModel.isEmployeeCodeValid && !this.employeeConfiguration.autoGenerateEmployeeCode) {
      var checkEmployeeExists = this.employeeList.find(f => f.employeeCode.toLowerCase() == this.employeeSetupModel.employeeCode.toLowerCase());
      if (checkEmployeeExists && checkEmployeeExists.tblEmployeeId != this.employeeSetupModel.tblEmployeeId) {
        this.validationModel.isEmployeeCodeValid = false;
        this.validationModel.employeeCodeValidationMessage = "Employee Code already exists.";
      }
      else {
        this.validationModel.isEmployeeCodeValid = true;
      }
    }

    this.validationModel.isFirstNameValid = this.employeeConfiguration.requiredFields.firstName && this.employeeSetupModel.firstName == "" ? false : true;
    this.validationModel.isLastNameValid = this.employeeConfiguration.requiredFields.lastName && this.employeeSetupModel.lastName == "" ? false : true;
    this.validationModel.isMobileValid = this.employeeConfiguration.requiredFields.mobile && this.employeeSetupModel.mobile == "" ? false : true;
    this.validationModel.isTelephoneValid = this.employeeConfiguration.requiredFields.telephone && this.employeeSetupModel.telephone == "" ? false : true;
    this.validationModel.isProfileImageValid = this.employeeConfiguration.requiredFields.profileImage && this.employeeSetupModel.profileImage == "" ? false : true;

    this.emailValidationModel = await this.appCode.onEmailValidation(this.employeeSetupModel.email, this.employeeConfiguration.requiredFields.email);
    this.passwordValidationModel = (this.loginFieldsDisabled == false && this.employeeSetupModel.webLogin == "Yes") ? await this.appCode.onPasswordValidation(this.password, (this.employeeSetupModel.webLogin == "Yes")) : new PasswordValidationModel();

    if (!this.validationModel.isFirstNameValid || !this.validationModel.isLastNameValid || !this.validationModel.isMobileValid
      || !this.validationModel.isTelephoneValid || !this.validationModel.isProfileImageValid
      || !this.emailValidationModel.isEmailIdValid
      || !this.passwordValidationModel.isPasswordValid
      || !this.validationModel.isContractorDDLValid || !this.validationModel.isDepartmentValid
    ) {
      this.isValidForm = false;
    }
    else {
      this.isValidForm = true;
    }

    //appenate user validation - check user exists in appenate
    if (this.employeeSetupModel.appenateUser == "Yes" && (this.employeeSetupModel.appenateUserId == "" || this.employeeSetupModel.appenateUserId == null)) {
      this.appenateCreateUser = new AppenateCreateUserModel();
      this.appenateCreateUser = this.employeeConfiguration.appenateCreateUser;

      this.CompanyId = this.appenateCreateUser.companyId;
      this.IntegrationKey = this.appenateCreateUser.integrationKey;
      this.Email = this.employeeSetupModel.email;

      // to check user exist on appenate
      this.userNameValidationModel = await this.appCode.checkUserNameExistsInAppenate(this.CompanyId, this.IntegrationKey, this.Email);
      if (!this.isValidForm || !this.userNameValidationModel.isValid) {
        this.isValidForm = false;
        return this.isValidForm;
      }
    }

    if (this.employeeSetupModel.webLogin == "Yes" && !this.loginFieldsDisabled && this.emailValidationModel.isEmailIdValid) {
      this.userNameValidationModel = await this.appCode.checkUserNameExists(this.employeeSetupModel.email, this.employeeSetupModel.userId);
      if (!this.isValidForm || !this.userNameValidationModel.isValid) {
        this.isValidForm = false;
      }
      return await this.isValidForm;
    }


    var confirmationMsg = "";
    if (this.employeeSetupModel.appenateUser == "No" && (this.employeeSetupModel.appenateUserId != "" && this.employeeSetupModel.appenateUserId != null)) {
      confirmationMsg = 'This action will deactivate mobile-app';
    }

    if (this.employeeSetupModel.webLogin == "No" && (this.employeeSetupModel.userId != "" && this.employeeSetupModel.userId != null)) {
      confirmationMsg = confirmationMsg != "" ? confirmationMsg + ' and web-app login.' : 'This action will deactivate web-app login.';
    }

    if (confirmationMsg != "") {
      this.loading = true;
      Swal.fire({
        title: 'Are you sure?',
        text: confirmationMsg,
        showCancelButton: true,
        confirmButtonText: 'Ok',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        cancelButtonText: 'No',
        allowOutsideClick: false
      }).then((result) => {
        if (result.value != undefined && result.value == true) {
          this.callSubmitMethod();
          return this.isValidForm;
        }
        else if (result.dismiss != undefined && (result.dismiss.toString() == "cancel")) {
          this.isValidForm = false;
          return this.isValidForm;
        }
        console.log(result);
      });
    }
    else {
      return await this.isValidForm;
    }


  }

  callSubmitMethod() {
    var tblEmployeeId = this.employeeSetupModel.tblEmployeeId;
    this.onSave().then(async (data) => {
      Swal.fire({
        text: (tblEmployeeId == 0 ? "Employee Added Successfully" : "Employee Updated Successfully"),
        confirmButtonText: 'Ok',
        confirmButtonColor: '#3085d6',
        allowOutsideClick: true
      }).then((result) => {
        this.onClear();
        this.getEmployeeList();
        this.loading = false;
        this.appCode.scrollTo('panelGrid');
      });
    });
  }

  // Submit Process
  async onSubmit() {
    this.loading = true;
    var result = await this.validateFormData();
    if (result != null && result != undefined) {
      if (result == true) {
        this.callSubmitMethod();
      }
      else {
        this.loading = false;
      }
    }
    else {
      this.loading = false;
    }
  }

  async onSave() {
    try {

      let loginOptionChange = false;
      const sendNotification = false;
      this.client = this.clientService.getClient();

      if (!this.client) {
        //sendNotification = this.client.isEmailVerificationRequired;
      }

      const tblEmployeeId = this.employeeSetupModel.tblEmployeeId;
      const contractorId = this.employeeSetupModel.tblContractorId;
      const departmentId = this.employeeSetupModel.tblDepartmentId;

      // Insert/update employee data
      const employeeId = await this.insertUpdateEmployeeData();
      this.employeeSetupModel.tblEmployeeId = parseInt(employeeId.toString());

      this.appenateCreateUser = this.employeeConfiguration.appenateCreateUser;
      this.appenateCreateUser.firstName = this.employeeSetupModel.firstName;
      this.appenateCreateUser.lastName = this.employeeSetupModel.lastName;
      this.appenateCreateUser.email = this.employeeSetupModel.email;
      this.appenateCreateUser.password = this.password;

      if (this.employeeSetupModel.appenateUser === "Yes") {
        if (this.employeeSetupModel.appenateUserId) {
          // Update appenate user
          await this.appCode.updateAppenateUser(this.appenateCreateUser);
        } else {
          // Create appenate user
          const result = await this.appCode.createAppenateUser(this.appenateCreateUser);
          this.employeeSetupModel.appenateUserId = result["id"];
          loginOptionChange = true;
        }
      } else if (this.employeeSetupModel.appenateUserId) {
        // Delete appenate user
        const appenateDeleteUser = new AppenateDeleteUserModel();
        appenateDeleteUser.integrationKey = this.employeeConfiguration.appenateCreateUser.integrationKey;
        appenateDeleteUser.companyId = this.employeeConfiguration.appenateCreateUser.companyId;
        appenateDeleteUser.id = this.employeeSetupModel.appenateUserId;
        await this.appCode.deleteAppenateUser(appenateDeleteUser);
        this.employeeSetupModel.appenateUserId = "";
        loginOptionChange = true;
      }

      if (this.employeeSetupModel.webLogin === "Yes") {
        if (!this.employeeSetupModel.userId) {
          const userData = {
            userName: this.employeeSetupModel.email,
            email: this.employeeSetupModel.email,
            password: this.password,
            firstName: this.employeeSetupModel.firstName,
            lastName: this.employeeSetupModel.lastName,
            isActive: true,
          };
          this.employeeSetupModel.userId = await this.appCode.createUser(userData, this.employeeConfiguration.employeeRoles, sendNotification);
          loginOptionChange = true;
        }
      } else if (this.employeeSetupModel.userId) {
        if (this.employeeSetupModel.webLogin === "No") {
          // Deactivate user
          await this.appCode.deactivateUser(this.employeeSetupModel.userId);
        } else if (this.loginFieldsDisabled) {
          // Reactivate user
          await this.appCode.reactivateUser(this.employeeSetupModel.userId);
        }
      }

      if (loginOptionChange) {
        const notificationModel = new NotificationModel();
        if (this.employeeSetupModel.webLogin === "Yes" && this.employeeSetupModel.appenateUser === "Yes") {
          notificationModel.emailFor = "webmobile";
        } else if (this.employeeSetupModel.webLogin === "Yes") {
          notificationModel.emailFor = "web";
        } else if (this.employeeSetupModel.appenateUser === "Yes") {
          notificationModel.emailFor = "mobile";
        }
        if (notificationModel.emailFor) {
          notificationModel.clientId = this.client.clientId;
          notificationModel.userId = this.employeeSetupModel.userId;
          notificationModel.email = this.employeeSetupModel.email;
          notificationModel.password = this.password;
          notificationModel.contractorId = contractorId.toString();
          notificationModel.departmentId = departmentId.toString();
          notificationModel.employeeId = employeeId.toString();
          const notificationResult = await this.appCode.sendVerificationEmailToUserAndAdmin(notificationModel);
        }
      }
    } catch (error) {
      // Handle errors here
    }
  }

  async insertUpdateEmployeeData() {
    try {
      this.employeeSetupModel.clientId = this.client.clientId;
      this.employeeSetupModel.formId = this.employeeConfiguration.formId;
      this.employeeSetupModel.autoGenerateCode = this.employeeConfiguration.autoGenerateEmployeeCode;

      if (this.employeeConfiguration.allowedFields.designation) {
        const selectedDesignation = this.designationList.find(f => f.tblDesignationId === this.employeeSetupModel.tblDesignationId);
        console.log(selectedDesignation);
        if (selectedDesignation) {
          this.employeeConfiguration.employeeRoles = [selectedDesignation.roleName];
        }
      }

      if (this.employeeSetupModel.tblEmployeeId === 0) {
        this.employeeSetupModel.createdBy = this.appCode.getCurrentUserName();
      } else {
        this.employeeSetupModel.updatedBy = this.appCode.getCurrentUserName();
      }

      const data = await this.employeeSetupService.postAddUpdateEmployee(this.employeeSetupModel);
      return data;
    } catch (error) {
      // Handle errors here
    }
  }


  // Email Validation
  // Email Validation using Pattern
  async onChangeEmail(newValue) {
    this.userNameValidationModel.isValid = true;
    this.emailValidationModel = await this.appCode.onEmailValidation(newValue, this.employeeConfiguration.requiredFields.email);
  }

  public sortChange(sort: SortDescriptor[]): void {
    this.sort = sort;
  }

  pageChange({ skip, take }: PageChangeEvent): void {
    this.skip = skip;
    this.pageSize = take;
    this.getEmployeeList();
  }

  public dataStateChange(state: DataStateChangeEvent): void {
    this.state = state;
    this.gridView = process(this.employeeList, this.state);
  }
  public exportToExcel(grid: GridComponent): void {
    grid.saveAsExcel();
  }
  // Bind All Data for excel Method
  public allData(): ExcelExportData {
    const result: ExcelExportData = {
      data: process(this.employeeList, {
      }).data,
    };
    return result;
  }
  // Get All Employee Details
  async getEmployeeList(contractorId: any = null) {
    this.userRoles = localStorage.getItem("Roles");
    //let client = localStorage.getItem("currentClient");
    //let joclient = JSON.parse(client);
    //this.clientId = joclient.clientId;
    let user = localStorage.getItem("currentUser");
    if (user) {
      let jouser = JSON.parse(user);
      this.userEmail = jouser.user.Email;
      this.clientId = jouser.user.ClientId;
    }

    //Global filter
    var globalFilterCondition = await this.appCode.getGlobalFilterCondition();
    if (this.clientId != '') {
      this.loading = true;
      this.employeeSetupService.getEmployee(this.clientId, this.userRoles, this.userEmail, globalFilterCondition)
        .then(async (data: any) => {
          var filterData = await data;
          if (this.employeeConfiguration.displayEmployeeByContractor == true) {
            // filterData = filterData.find(w=> w.tblContractorId == contractorId);
            filterData = filterData.filter(w => w.tblContractorId === contractorId);

          }

          this.employeeList = filterData;
          this.gridView = process(this.employeeList, this.state);
          this.gridRowCount = this.gridView.total;
          this.loading = false;
        }, (error) => {
          console.error("Error:   " + JSON.stringify(error));
          this.loading = false;
        });
    }
  }

  // ACTION - EDIT - Employee By ID
  onEdit(employeeId, type) {
    this.onClear();
    this.btnName = "UPDATE";
    var profileImage = "";
    this.addEditFormName = this.employeeConfiguration.editFormName;

    this.loading = true;
    this.employeeSetupService.getEmployeeByID(employeeId, type)
      .then((data: any) => {
        for (let res of data) {
          profileImage = (res.profileImage != null && res.profileImage != "" ? res.profileImage : "../../../../assets/img/no-photo-available.png");
          this.employeeSetupModel.tblEmployeeId = res.tblEmployeeId;
          this.addEditPanelVisibility();
          this.employeeSetupModel.formId = res.formId;
          this.employeeSetupModel.employeeCode = res.employeeCode;
          this.employeeSetupModel.firstName = res.firstName;
          this.employeeSetupModel.lastName = res.lastName;
          this.employeeSetupModel.mobile = res.mobile;
          this.employeeSetupModel.telephone = res.telephone;
          this.employeeSetupModel.email = res.email;
          this.employeeSetupModel.profileImage = profileImage;
          this.employeeSetupModel.clientId = res.clientId;
          this.employeeSetupModel.webLogin = res.webLogin;
          this.employeeSetupModel.tblContractorId = res.tblContractorId;
          this.employeeSetupModel.tblDepartmentId = res.tblDepartmentId;
          this.employeeSetupModel.appenateUser = res.appenateUser;
          this.employeeSetupModel.appenateUserId = res.appenateUserId;
          this.employeeSetupModel.tblDesignationId = res.tblDesignationId;

          this.employeeSetupModel.userId = res.userId;
          this.password = ((res.userId != null && res.userId != "") || res.appenateUser == "Yes") ? "xxxxxxxxxx" : "";//need to keep xxx password when existing weblogin = yes.
          this.loginFieldsDisabled = ((res.userId != null && res.userId != "") || res.appenateUser == "Yes") ? true : false;

          // for IMVO client
          if (this.clientId == '175') {
            this.appDepartment.getDepartmentList(res.tblDepartmentId);
          }
          this.contractorConfiguration.selectedValueContractorDropDownList = res.tblContractorId;
          this.appContractor.setContractorId(res.tblContractorId);
          this.departmentConfiguration.selectedValueDepartmentDropDownList[0] = res.tblDepartmentId;
          this.departmentConfiguration.selectedValueDepartmentDropDownList[1] = res.tblDepartmentId2;

          this.outpkTableId.emit(String(this.employeeSetupModel.tblEmployeeId));
        }
        this.loading = false;
      }, (error) => {
        console.error("Error:   " + JSON.stringify(error));
        this.loading = false;
      });
  }

  // ACTION - DELETE
  onDelete(appenateUserId, employeeId, type) {
    this.loading = true;
    Swal.fire({
      title: 'Are you sure?',
      text: 'You want to delete this employee?',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      cancelButtonText: 'No',
      allowOutsideClick: false
    }).then((result) => {
      if (result.value === true) {
        this.employeeSetupService.getEmployeeByID(employeeId, type) // delete employee from tblEmployee
          .then(() => {
            this.onClear();
            // Get All Employee Details
            this.getEmployeeList();
          }, (error) => {
            console.error("Error:   " + JSON.stringify(error));
            this.loading = false;
          });
        //if (this.employeeSetupModel.appenateUser == "Yes" && this.employeeSetupModel.appenateUserId != "") {  
        this.appenateDeleteUser = new AppenateDeleteUserModel();
        this.appenateDeleteUser.integrationKey = this.employeeConfiguration.appenateCreateUser.integrationKey;
        this.appenateDeleteUser.companyId = this.employeeConfiguration.appenateCreateUser.companyId;
        this.appenateDeleteUser.id = appenateUserId;
        this.appCode.deleteAppenateUser(this.appenateDeleteUser); // delete employee from Appenate 
        //}
      } else if (result.dismiss) {
        // Get All Employee Details
        this.getEmployeeList();
      }
    });
  }

  // Cancel
  onCancel() {
    this.onClear();
    if (this.employeeConfiguration.redirectUrl != "") {
      this.router.navigate([this.employeeConfiguration.redirectUrl]);
    }
    else {
      this.scrollTo('panelGrid');
    }
  }

  // Image - Binary
  onUploadChange(evt: any) {
    var files = evt.target.files;
    var file = files[0];
    if (files && file) {
      var reader = new FileReader();
      reader.onload = this._handleReaderLoaded.bind(this);
      reader.readAsBinaryString(file);
    }
  }

  _handleReaderLoaded(readerEvt) {
    var binaryString = readerEvt.target.result;
    this.base64textString = 'data:image/png;base64,' + btoa(binaryString);
    this.employeeSetupModel.profileImage = this.base64textString.toString();
  }

  // scrollTo - parent
  scrollTo(panelId: string) {
    this.appCode.scrollTo(panelId);
  }


  parentOutPkTableId(pkTableId: number) {
    this.validationModel.isContractorDDLValid = pkTableId > 0 ? true : false;
    this.contractorConfiguration.selectedValueContractorDropDownList = pkTableId.toString();
    this.employeeSetupModel.tblContractorId = pkTableId;
  }
  openAddEditInModlalPopup() {
    this.onClear();
    this.addEditFormName = this.employeeConfiguration.addFormName;
    if (this.employeeConfiguration.addEditInModalPopUp) {
      this.employeeSetupModel.tblEmployeeId = 0;
      this.addEditPanelVisibility();
      this.showModal = true;
    }
    else {
      this.employeeSetupModel.tblEmployeeId = 0;
      this.addEditPanelVisibility();
      this.appCode.scrollTo("panelAddEdit");
    }
  }

  // Password Pattern
  async validatePassword(event) {
    this.passwordValidationModel = await this.appCode.onPasswordValidation(event, true);
  }

  closeSelectEmployeeModlalPopup() {
    this.selectEmployeeSectionShowModal = false;
    this.selectEmployeeSectionShowModalClass = "modal fade";
  }

  openSelectEmployeeModlalPopup() {
    this.selectEmployeeSectionShowModal = true;
    this.selectEmployeeSectionShowModalClass = "modal fade in";
  }

  selectionChange(event: any) {
    alert(event);
  }

  selectedRowChange(selectionEvent: SelectionEvent) {

    console.log(selectionEvent.selectedRows[0]);
    var res = selectionEvent.selectedRows[0].dataItem;
    this.employeeSetupModel = res;

    this.contractorConfiguration.selectedValueContractorDropDownList = res.tblContractorId;
    this.departmentConfiguration.selectedValueDepartmentDropDownList = res.tblDepartmentId;
    this.outpkTableId.emit(this.employeeSetupModel.tblEmployeeId.toString());
    this.closeSelectEmployeeModlalPopup();
  }
  closeAddEditModlalPopup() {
    this.onClear();
    this.showModal = false;
  }
  closeAddemployeeModlalPopup() {
    this.onClear();
    this.showModal = false;
  }

  onDropdownChange() {
    this.emailLabelText = "Email";
    this.passwordLabelText = "Password for ";
    if (this.employeeSetupModel.webLogin == "Yes") {
      this.passwordLabelText += "Web";
      this.emailLabelText += " / Username";
    }

    if (this.employeeSetupModel.appenateUser == "Yes") {
      this.passwordLabelText += this.employeeSetupModel.webLogin == "Yes" ? " & Mobile App" : "Mobile App";
      this.emailLabelText += " / Mobile App";
    }
  }

  onChangeTelephone(newValue: any, fieldName: string) {
    if (fieldName == "telephone1") {
      var data = this.appCode.validateFormatedText(newValue, this.employeeConfiguration.fieldsFormat.telephone1);
      this.employeeSetupModel.mobile = data;
    }
    else if (fieldName == "telephone2") {
      var data = this.appCode.validateFormatedText(newValue, this.employeeConfiguration.fieldsFormat.telephone2);
      this.employeeSetupModel.telephone = data;
    }
  }

  setSelectedDepartmentIds(ids: any) {
    //this.model.tblDepartmentId = parseInt(ids[0]);
    //this.model.tblDepartmentId2 = parseInt(ids[1]);

    this.validationModel.isDepartmentValid = ids[0] > 0 ? true : false;
    //this.departmentConfiguration.selectedValueDepartmentDropDownList[0] = pkTableId.toString();
    this.employeeSetupModel.tblDepartmentId = ids[0];
    this.employeeSetupModel.tblDepartmentId2 = ids[1];
  }

  webLoginDefaultValue(flag: string) {
    this.employeeSetupModel.webLogin = flag;
    this.onDropdownChange();
  }
  async bindDesignationList() {
    this.designationList = await this.employeeSetupService.getDesignationList();
  }

  addEditPanelVisibility() {
    if (this.employeeConfiguration.allowAdd && this.employeeSetupModel.tblEmployeeId == 0) {
      this.panelAddEditVisible = true;
      this.appCode.scrollTo('panelAddEdit');
    }
    else if (this.employeeConfiguration.allowEdit && this.employeeSetupModel.tblEmployeeId > 0) {
      this.panelAddEditVisible = true;
      this.appCode.scrollTo('panelAddEdit');
    }
    else {
      this.panelAddEditVisible = false;
      this.appCode.scrollTo('panelGrid');
    }
  }
}
